export type Fetch = typeof fetch
export type FetchConfig = (nextFetch: Fetch) => Fetch

export type FetchDialogMode = 'info' | 'retry' | 'silent'

declare global {
  export interface RequestInit {
    /**
     * Si true, active le sablier pour le fetch.
     * Si number, active le sablier pour le fetch avec un délai en ms
     */
    sablier?: boolean | number
    /**
     * Si true, n'attend pas la lecture de body du fetch pour cacher le sablier
     */
    sablierNoWaitReadBody?: true
    /**
     * Si true, annule automatiquement la requête si elle n'est pas terminée avant le prochain fetch
     */
    autoCancel?: boolean
    /**
     * Mode de dialogue pour les erreurs de requête
     */
    dialogMode?: FetchDialogMode
    /**
     * Liste des codes d'erreur http à exclure du mode de dialogue
     */
    dialogExcludeErrors?: number[]
    /**
     * A utiliser pour le Upload de fichiers
     */
    noDefaultContentType?: boolean
    /**
     * Active le cache de la réponse de la requête
     */
    appCache?: true
    /**
     * Durée de cache de la réponse de la requête en secondes
     */
    appCacheDurationEnSecondes?: number
    /**
     * Ajoute une clé supplémentaire au cache de la réponse de la requête
     */
    appCacheAddKey?: string | number | Array<string | number | undefined | null>
    /**
     *  Demande le rechargement de la page sur une erreur de concurrence
     */
    reloadPageOnConcurrencyException?: true
    /**
     * Désactive le blocage imperso sur les opération d'écritures
     * */
    blocageImpersoDisabled?: true
  }
}

export class ConcurrencyException extends Error { }
